// extracted by mini-css-extract-plugin
export default {"priceSummary":"price-section_priceSummary__rax6w","priceWrapper":"price-section_priceWrapper__7qqP2"};